<div *ngIf="isLoading">
  <po-loading-overlay [p-text]="text" [p-size]="size">
  </po-loading-overlay>
</div>

<po-page-default>
  <div class="po-row">
    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
      <p class="po-font-title">Contagem Movimentação OP</p>
    </div>
  </div>

  <div class="po-row po-flex po-mt-2 po-mb-2" style="justify-content: flex-start;">
    <po-button p-kind="primary" p-icon="an an-plus" (p-click)="openModal()" p-label="Nova Contagem"
      class="po-mt-1 po-xl-2 po-lg-4 po-md-12 po-sm-12 po-text-center">
    </po-button>
  </div>

  <po-table [p-columns]="columns" [p-items]="items">

    <ng-template p-table-cell-template let-row="row" let-column="column">
      <ng-container *ngIf="column.property === 'action'">
        <div class="action-buttons">
          <po-button p-size="small" p-kind="secondary" p-icon="po-icon-delete" p-danger="true"
            (p-click)="confirmDeleteCount(row.branchCode, row.code)">
          </po-button>

          <po-button p-size="small" p-kind="secondary" p-icon="po-icon-arrow-right"
            (p-click)="goToCountDetails(row.branchCode, row.code)">
          </po-button>
        </div>
      </ng-container>
    </ng-template>



  </po-table>
</po-page-default>

<po-modal #countModal p-title="Nova Contagem" [p-primary-action]="{ label: 'Continuar', action: saveCount.bind(this)}"
  [p-secondary-action]="{ label: 'Voltar', action: closeModal.bind(this) }">
  <div class="po-p-3">
    <po-input [(ngModel)]="countDescription" p-label="Descrição" p-placeholder="Escreva uma descrição (opcional). Você pode prosseguir clicando em Continuar." name="countDescription">
    </po-input>
    
  </div>
</po-modal>

<app-toaster></app-toaster>